import { createContext } from "react";
import { Entity } from "@common/types/entity";

interface Context {
    entity?: Entity;
}

export const EntityContext = createContext<Context>({});
